import { Component, OnInit, Input, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { BuyerMoreArticlesService } from './more-articles.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-more-articles',
  templateUrl: './more-articles.component.html',
  styleUrls: ['./more-articles.component.scss']
})
export class MoreArticlesComponent implements OnInit {
	@Input() class: string;
	@Input() sticky: boolean = false; // Default false

	public assistance_record:any = {};
	public article_id:string;
  	public stick: boolean = false;
  	constructor(
		private _morearticlesservice: BuyerMoreArticlesService,
		private _route: ActivatedRoute,
	) { }

  	ngOnInit(): void {
		this.article_id = this._route.snapshot.paramMap.get('id');
		this.getassistance();
  	}
  	disabled = false;
  	// @HostListener Decorator
    @HostListener("window:scroll", [])
    onWindowScroll() {
        let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  	    if (number >= 150 && window.innerWidth > 400) { 
  	        this.stick = true;
  	     } else {
  	         this.stick = false;
  	     }
    }

	getassistance() {
        this._morearticlesservice.getassistance({id: this.article_id}).subscribe((data) => {
            if(data['status'] == "success"){
                this.assistance_record = data['record'];
            }
        },(error) => {
        });
    }
}
